// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown-signataires {
  width: 100%;
  margin-bottom: 1rem;
}

.signataire-select {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  background-color: #fff;
}

.error-message {
  color: #e53e3e;
  margin-top: 0.25rem;
  font-size: 0.875rem;
}`, "",{"version":3,"sources":["webpack://./src/composants/DropDownSignataires/DropDownSignataires.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB","sourcesContent":[".dropdown-signataires {\n  width: 100%;\n  margin-bottom: 1rem;\n}\n\n.signataire-select {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 14px;\n  background-color: #fff;\n}\n\n.error-message {\n  color: #e53e3e;\n  margin-top: 0.25rem;\n  font-size: 0.875rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
